// removed by extract-text-webpack-plugin
module.exports = {"pickerSpin":"styles__pickerSpin","pickerSpinAfter":"styles__pickerSpinAfter"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/show-page/styles/index.less
 ** module id = 452
 ** module chunks = 1
 **/